import loadable from '@loadable/component';

// 懒加载组件
const PaymentApplicationManagement = loadable(() => import('./paymentApplicationManagement/PaymentApplicationManagement'));
const PaymentApplicationInvoiceModify = loadable(() => import('./paymentApplicationManagement/paymentApplicationInvoiceModify/PaymentApplicationInvoiceModify'));

export const subRoutes = [
  {
    // M830258005: 供应商：发票上交申请管理
    path: '/PaymentApplicationManagement',
    component: PaymentApplicationManagement
  },
  {
    // M830258005: 供应商：发票上交申请管理-编辑
    path: '/PaymentApplicationInvoiceModify',
    component: PaymentApplicationInvoiceModify
  }
];
